import React from 'react';
import s from './InputCurrency.scss'

const SelectBrandCar = ({
    value,
    name,
    className = '',
    options,
    onChange,
    errors
}) => {
    return(
        <div className={`${s.container} ${className}`}>
            <select
                name={`${name}`}
                onChange={onChange}
                className={s.selectCar}
            >   
                <optgroup>
                    {options[0] && 
                        <option value={options[0].id} selected={value && options[0].id == value.id || options[0].id == value} >{options[0].name}</option>
                    }    
                    {options && options.map((option, index) =>
                        (option.priority === 0) &&
                        <option key={index} value={option.id} selected={value && option.id == value.id || option.id == value} >{option.name}</option>
                    )}
                </optgroup>
                <optgroup label='──────────────────'>
                    {options && options.map((option, index) =>
                        (option.priority === 10) && 
                        <option key={index} value={option.id} selected={value && option.id == value.id || option.id == value} >{option.name}</option>      
                    )}
                </optgroup>
            </select>
            {(errors && errors[0]) ? <p autoFocus className={s.error}>{errors[0]}</p> : ''}
        </div>
    );
}
export default SelectBrandCar
